import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils";
import { oAuth } from "@libs/wechat";

export default function toLogin(push, backUrl) {
  store.commit("PETLOGOUT");
  const { fullPath, name } = router.currentRoute;
  cookie.set("pet_login_back_url", backUrl || fullPath);
	if (name !== "PetAdminLogin") {
		push
			? router.push({ path: "/petAdmin/login" })
			: router.replace({ path: "/petAdmin/login" });
	}
}
